import { Dispatch } from "redux";
import { setCurrentUserInfo } from "./actions";
import { getCurrentUserInfo } from "./services";

export const getCurrentUserInfoDispatch = (accessToken: string) => async (dispatch: Dispatch) => {
    const currentUserInfo: any = await getCurrentUserInfo(accessToken);
    dispatch(setCurrentUserInfo(currentUserInfo));
};
